import oneTooltip from '@/components/Tooltip.vue'
// import Vue from 'vue'

// // 标签引入
// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.component('Tooltip',Tooltip)
// }

// Tooltip.install = Vue => {
// if (!Vue) {
// window.Vue = Vue = _Vue
// }
// Vue.component(Tooltip.name, Tooltip)
// }
const components = {
  install(Vue) {
      Vue.component('one-tooltip', oneTooltip)
  }
}
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(components)
}
export default components;




// WEBPACK FOOTER //
// ./index.js